import React from "react";
import notFoundImg from "../../image/404.png";
import { Link } from "react-router-dom";
const PageNotFound = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center bg-light px-3"
      style={{ height: "100vh", width: "100vw" }}
    >
      <img
        src={notFoundImg}
        alt="404 Not Found"
        style={{ maxWidth: "400px", width: "100%" }}
      />
      <h4 className="fw-bold text-primary">Oops! Page not found</h4>
      <p className="small text-muted mb-3">
        The page you’re looking for doesn’t exist or has been moved.
      </p>
      <Link to="/" className="btn btn-outline-primary btn-lg shadow">
        ← Back to Home
      </Link>
    </div>
  );
};

export default PageNotFound;
